<template>
  <div class="d-flex align-center">
    <LanguageChanger :color="color" />
    <slot></slot>
  </div>
</template>
<script lang="ts">
import { Component, Vue, Prop } from "vue-property-decorator";
import LanguageChanger from "./LanguageChanger.vue";

@Component({
  name: "AppHeaderActions",
  components: {
    LanguageChanger,
  },
})
export default class extends Vue {
  @Prop(Boolean) small!: boolean;
  get color() {
    return this.small ? "primary" : "accent";
  }
}
</script>
<style lang="scss"></style>
